import { GET_COMPETENCIES } from "@/api/master-data/competency/competency";

const state = {
    competencyOptions: [],
    loading: false
};

const mutations = {
    SET_COMPETENCY_OPTIONS: (state, payload) => {
        state.competencyOptions = payload || [];
    },
    SET_LOADING: (state, payload) => {
        state.loading = payload;
    }
};

const getters = {
    getCompetencyOptions: (state) => state.competencyOptions,
    getLoading: (state) => state.loading
};

const actions = {
    // Get all competencies without pagination (for dropdown/select options)
    getAllCompetencies: async ({ commit }, params = {}) => {
        commit('SET_LOADING', true);
        try {
            // Call API without limit and page params
            const cleanParams = { ...params };
            delete cleanParams.limit;
            delete cleanParams.page;
            
            const response = await GET_COMPETENCIES(cleanParams);
            if (response.data.httpCode === 200) {
                commit('SET_COMPETENCY_OPTIONS', response.data.data.data || []);
                return response.data.data.data || [];
            } else {
                commit('SET_COMPETENCY_OPTIONS', []);
                return [];
            }
        } catch (error) {
            console.error('Error fetching competency options:', error);
            commit('SET_COMPETENCY_OPTIONS', []);
            throw error;
        } finally {
            commit('SET_LOADING', false);
        }
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
};
